import {
  FormControl,
  InputBase,
  MenuItem,
  MenuProps,
  Select as MuiSelect,
  Theme,
} from '@mui/material'
import {styled} from '@mui/material/styles'
import {ReactComponent as ChevronIcon} from '@/assets/svgs/Chevron.svg'
import {InputBaseProps} from '@mui/material/InputBase/InputBase'

interface InputCustomBaseProps extends InputBaseProps {
  fontSize: string
  theme?: Theme
}

const StyledInput = styled(InputBase)(
  ({fontSize, theme}: InputCustomBaseProps) => ({
    'label + &': {
      marginTop: theme?.spacing(3),
    },
    '& .MuiInputBase-input': {
      display: 'flex',
      alignItems: 'center',
      fontSize: fontSize ? fontSize : 20,
      lineHeight: 1,
      borderRadius: 50,
      padding: '4px 40px 4px 15px!important',
      color: '#FFFDF0',
      backgroundColor: '#0F0A00',
      border: '1px solid #FFD7AE',

      '&:focus': {
        borderRadius: 50,
      },
      '&[aria-expanded="true"]': {
        borderRadius: '20px 20px 0 0',
        paddingBottom: '5px !important',
        borderBottom: 'none',
      },
    },
  })
)

const StyledIcon = styled(ChevronIcon)({
  right: '15px !important',
})

const StyledMenuItem = styled(MenuItem)({
  '&.MuiMenuItem-root': {
    padding: '10px 15px',
    backgroundColor: '#0F0A00',
    color: '#fff',
    fontSize: 10,
    lineHeight: '20px',

    '&:hover': {
      backgroundColor: '#0F0A00',
      color: '#FF9326',
    },
  },
})

const menuProps: Partial<MenuProps> = {
  disableScrollLock: true,
  disableAutoFocusItem: true,
  PaperProps: {
    sx: {
      transition: 'none !important',
      transform: 'none !important',
      animation: 'none !important',
      borderRadius: '0 0 20px 20px',
      borderRight: '1px solid #FFD7AE',
      borderBottom: '1px solid #FFD7AE',
      borderLeft: '1px solid #FFD7AE',
      boxSizing: 'border-box',
      borderTopColor: '#0F0A00',
      backgroundColor: '#0F0A00',
      maxHeight: '305px',

      '& .MuiList-root': {
        padding: 0,

        '.MuiMenuItem-root:first-child': {
          marginTop: '6px',
        },
      },
    },
  },
}

// TODO: fix any
const Select = ({
  value,
  list,
  onChange,
  fontSize = 20,
  getDisabledItem = () => false,
}: any) => {
  return (
    <FormControl variant="standard" sx={{width: '100%'}}>
      <MuiSelect
        input={<StyledInput fontSize={fontSize} />}
        MenuProps={menuProps}
        IconComponent={StyledIcon}
        value={value}
        onChange={onChange}>
        {/* TODO: fix any */}
        {list.map((item: any) => (
          <StyledMenuItem
            disabled={getDisabledItem(item)}
            style={{fontSize}}
            value={item.value}
            key={item.value}>
            {item.label}
          </StyledMenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  )
}

export default Select
